"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _mobxUtils = require("mobx-utils");
var _asyncSearchResults = _interopRequireDefault(require("../api/async-search-results.store"));
var _marketingBanners = _interopRequireDefault(require("../api/marketing-banners.store"));
var _topAirlines = _interopRequireDefault(require("../api/top-airlines.store"));
var _fareCalendar = _interopRequireDefault(require("../api/fare-calendar.store"));
var _filter = _interopRequireDefault(require("../../services/filter.service"));
var _sort = _interopRequireDefault(require("../../services/sort.service"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _minBy2 = _interopRequireDefault(require("lodash/minBy"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _filter2 = _interopRequireDefault(require("../../utils/filter.utils"));
var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));
var _sort2 = _interopRequireWildcard(require("../../utils/sort.utils"));
var _group = _interopRequireWildcard(require("../../utils/group.utils"));
var _searchResults = require("../../utils/search-results.utils");
var _search = _interopRequireDefault(require("../../utils/search.utils"));
var _itinerary = require("../../utils/itinerary.utils");
var _fareCalendar2 = _interopRequireDefault(require("../../utils/fare-calendar.utils"));
var _itineraryWithBaggage = _interopRequireDefault(require("../../factories/itinerary-with-baggage.factory"));
var _constants = require("../../constants");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var FlightsAsyncSearchPageStore = exports.default = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, _dec12 = _mobx.action.bound, _dec13 = _mobx.action.bound, _dec14 = _mobx.action.bound, _dec15 = _mobx.action.bound, _dec16 = _mobx.action.bound, _dec17 = _mobx.action.bound, _dec18 = _mobx.action.bound, _dec19 = _mobx.action.bound, _dec20 = _mobx.action.bound, _dec21 = _mobx.action.bound, _dec22 = _mobx.action.bound, _dec23 = _mobx.action.bound, _dec24 = _mobx.action.bound, _dec25 = _mobx.action.bound, _dec26 = _mobx.action.bound, _dec27 = _mobx.action.bound, (_class = function () {
  function FlightsAsyncSearchPageStore(initialState, $env) {
    var _this = this;
    if (initialState === void 0) {
      initialState = {};
    }
    (0, _classCallCheck2.default)(this, FlightsAsyncSearchPageStore);
    (0, _initializerDefineProperty2.default)(this, "filtersState", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "filterKeys", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "appliedFilters", _descriptor3, this);
    (0, _initializerDefineProperty2.default)(this, "sortKey", _descriptor4, this);
    (0, _initializerDefineProperty2.default)(this, "searchQuery", _descriptor5, this);
    (0, _initializerDefineProperty2.default)(this, "dateRange", _descriptor6, this);
    (0, _initializerDefineProperty2.default)(this, "groupPaths", _descriptor7, this);
    (0, _initializerDefineProperty2.default)(this, "groupsState", _descriptor8, this);
    (0, _initializerDefineProperty2.default)(this, "selectedFlightId", _descriptor9, this);
    (0, _initializerDefineProperty2.default)(this, "selectedExtraBaggageOption", _descriptor10, this);
    (0, _initializerDefineProperty2.default)(this, "minGroupLength", _descriptor11, this);
    (0, _initializerDefineProperty2.default)(this, "isSorted", _descriptor12, this);
    this.getGroupedByLegSearchResult = (0, _mobxUtils.computedFn)(function (index) {
      return _this.groupedByLegSearchResults[index];
    });
    this.$env = $env;
    this.searchResults = new _asyncSearchResults.default(initialState.searchResults, $env);
    this.fareCalendar = new _fareCalendar.default(initialState.fareCalendar, $env);
    this.marketingBanners = new _marketingBanners.default(initialState.marketingBanners, $env);
    this.topAirlines = new _topAirlines.default(initialState.topAirlines, $env);
    (0, _mobx.autorun)(function () {
      return _this.filtersParams && _this.updateAppliedFilters();
    });
  }
  (0, _createClass2.default)(FlightsAsyncSearchPageStore, [{
    key: "allSearchResults",
    get: function get() {
      return this.searchResults.itineraries;
    }
  }, {
    key: "flightsFiltersParams",
    get: function get() {
      return (0, _map2.default)(this.allSearchResults, 'filterParams');
    }
  }, {
    key: "filtersData",
    get: function get() {
      return _filter2.default.extractData(this.flightsFiltersParams, this.filterKeys);
    }
  }, {
    key: "filtersParams",
    get: function get() {
      return _filter2.default.extractAllParams(this.filtersState);
    }
  }, {
    key: "filtersQuery",
    get: function get() {
      return _filter2.default.extractAllQuery(this.filtersParams);
    }
  }, {
    key: "appliedFiltersCount",
    get: function get() {
      return (0, _get2.default)(this.appliedFilters, 'length');
    }
  }, {
    key: "filteredSearchResults",
    get: function get() {
      return _filter2.default.execute(this.allSearchResults, this.filtersParams);
    }
  }, {
    key: "sortedSearchResults",
    get: function get() {
      return (0, _sort2.default)(this.filteredSearchResults, this.sortKey);
    }
  }, {
    key: "groupedSearchResults",
    get: function get() {
      return (0, _group.default)(this.sortedSearchResults, this.groupPaths, this.minGroupLength);
    }
  }, {
    key: "groupedByLegSearchResults",
    get: function get() {
      return (0, _group.getGroupedByLegSearchResults)({
        groupsState: this.groupsState,
        itineraryLegHashMap: this.searchResults.itineraryLegHashMap,
        legHashMap: this.searchResults.legHashMap
      });
    }
  }, {
    key: "sortPriceHashMap",
    get: function get() {
      return (0, _sort2.getSortPriceHashMap)(this.filteredSearchResults);
    }
  }, {
    key: "sortPriceDurationHashMap",
    get: function get() {
      return (0, _sort2.getSortPriceDurationHashMap)(this.filteredSearchResults);
    }
  }, {
    key: "flexibleFlightsAvailable",
    get: function get() {
      return !(0, _isEmpty2.default)((0, _intersection2.default)(_constants.FLEX_AIRLINES, this.availableAirlines));
    }
  }, {
    key: "sortItinerariesHashMap",
    get: function get() {
      return (0, _sort2.getSortItinerariesHashMap)(this.filteredSearchResults);
    }
  }, {
    key: "topPicks",
    get: function get() {
      return (0, _sort2.getTopPicks)(this.sortItinerariesHashMap);
    }
  }, {
    key: "topPicksHashMap",
    get: function get() {
      return (0, _sort2.getTopPicksHashMap)(this.filteredSearchResults, this.groupedSearchResults);
    }
  }, {
    key: "resultsWithoutTopPicks",
    get: function get() {
      return (0, _sort2.getResultsWithoutTopPicks)({
        topPicks: this.topPicks,
        searchResults: this.groupedSearchResults
      });
    }
  }, {
    key: "isTopPicksReady",
    get: function get() {
      return !this.isSorted && !(0, _isEmpty2.default)(this.resultsWithoutTopPicks);
    }
  }, {
    key: "$sort",
    get: function get() {
      return (0, _sort.default)({
        sortItinerariesHashMap: this.sortItinerariesHashMap
      });
    }
  }, {
    key: "resultsCheapestPrice",
    get: function get() {
      return (0, _get2.default)((0, _minBy2.default)(this.filteredSearchResults, 'totalPrice'), 'totalPrice', 0);
    }
  }, {
    key: "groupCheapestPriceByDate",
    get: function get() {
      return (0, _group.getGroupedCheapestPriceByDate)(this.filteredSearchResults);
    }
  }, {
    key: "isFiltered",
    get: function get() {
      return !!this.filtersQuery;
    }
  }, {
    key: "firstNearbyIndex",
    get: function get() {
      return (0, _searchResults.getFirstNearbyIndex)(this.groupedSearchResults);
    }
  }, {
    key: "hasNoResults",
    get: function get() {
      return this.searchResults.hasError || this.searchResults.isCompleted && !this.allSearchResults.length;
    }
  }, {
    key: "hasFilters",
    get: function get() {
      return !(0, _isEmpty2.default)(this.filtersData);
    }
  }, {
    key: "shouldResetFilters",
    get: function get() {
      return this.searchResults.isCompleted && !this.hasNoResults && !this.filteredSearchResults.length;
    }
  }, {
    key: "isMultiCity",
    get: function get() {
      return _search.default.checkMultiCity(this.searchQuery);
    }
  }, {
    key: "isEconomy",
    get: function get() {
      return _search.default.checkEconomyCabin(this.searchQuery);
    }
  }, {
    key: "hasAdultsOnly",
    get: function get() {
      return !this.searchQuery.includes('Child') && !this.searchQuery.includes('Infant');
    }
  }, {
    key: "isFareCalendarAvailable",
    get: function get() {
      return this.isEconomy && !this.isMultiCity;
    }
  }, {
    key: "shouldComparePricing",
    get: function get() {
      return this.fareCalendar.isFetched && this.searchResults.isCompleted;
    }
  }, {
    key: "pricingFilters",
    get: function get() {
      return _fareCalendar2.default.getPricingFilters(this.filtersQuery, this.filtersData);
    }
  }, {
    key: "searchRoute",
    get: function get() {
      return _search.default.getRouteFromQuery(this.searchQuery);
    }
  }, {
    key: "displayPriceFilterState",
    get: function get() {
      return _filter2.default.getDisplayPriceFilterState(this.filtersState.price, this.$env.currency);
    }
  }, {
    key: "mergedAirlineFilterState",
    get: function get() {
      return _filter2.default.merge(this.filtersState.airline);
    }
  }, {
    key: "availableAirlines",
    get: function get() {
      return (0, _map2.default)(this.filtersState.airline, 'code');
    }
  }, {
    key: "marketingCampaigns",
    get: function get() {
      return this.marketingBanners.getValidCampaigns({
        route: this.searchRoute,
        airlines: this.availableAirlines,
        searchType: this.searchResults.searchRequest.searchType,
        isDomesticKSA: this.searchResults.searchRequest.isDomesticKSA
      });
    }
  }, {
    key: "marketingCampaignsMap",
    get: function get() {
      return (0, _keyBy2.default)(this.marketingCampaigns, function (campaign) {
        return campaign.position;
      });
    }
  }, {
    key: "topCampaign",
    get: function get() {
      return this.marketingBanners.topCampaign({
        route: this.searchRoute,
        airlines: this.availableAirlines,
        searchType: this.searchResults.searchRequest.searchType,
        isDomesticKSA: this.searchResults.searchRequest.isDomesticKSA
      });
    }
  }, {
    key: "searchTopAirlines",
    get: function get() {
      return this.topAirlines.getValidTopAirlines({
        route: this.searchRoute,
        airlines: this.availableAirlines
      });
    }
  }, {
    key: "baseDepartureDate",
    get: function get() {
      return _search.default.getDepartureDateFromQuery(this.searchQuery);
    }
  }, {
    key: "baseReturnDate",
    get: function get() {
      return _search.default.getReturnDateFromQuery(this.searchQuery);
    }
  }, {
    key: "basePricingKey",
    get: function get() {
      return _fareCalendar2.default.constructPricingKey(this.baseDepartureDate, this.baseReturnDate);
    }
  }, {
    key: "departureDateRange",
    get: function get() {
      return _fareCalendar2.default.generateFareCalendarDateRange(this.baseDepartureDate, this.dateRange);
    }
  }, {
    key: "returnDateRange",
    get: function get() {
      return _fareCalendar2.default.generateFareCalendarDateRange(this.baseReturnDate, this.dateRange);
    }
  }, {
    key: "$filter",
    get: function get() {
      return (0, _filter.default)({
        filtersState: this.filtersState,
        filtersParams: this.filtersParams
      });
    }
  }, {
    key: "hasNearbyAirports",
    get: function get() {
      return (0, _some2.default)(this.searchResults.itineraries, function (i) {
        return i.hasNearbyOrigin || i.hasNearbyDestination;
      });
    }
  }, {
    key: "parseSearchQuery",
    get: function get() {
      return _search.default.getParsedSearchQuery(this.searchQuery);
    }
  }, {
    key: "availableAppliedFilters",
    get: function get() {
      return _filter2.default.getAvailableAppliedFilters(this.appliedFilters, this.searchTopAirlines);
    }
  }, {
    key: "totalFlightsCount",
    get: function get() {
      return (0, _get2.default)(this.allSearchResults, 'length');
    }
  }, {
    key: "filteredFlightsCount",
    get: function get() {
      return (0, _get2.default)(this.filteredSearchResults, 'length');
    }
  }, {
    key: "hasQuickFilters",
    get: function get() {
      return !(0, _isEmpty2.default)(this.searchTopAirlines) || !!(0, _find2.default)(this.filtersState.maxStop, {
        code: 0,
        isAvailable: true
      });
    }
  }, {
    key: "hasAppliedFilters",
    get: function get() {
      return !(0, _isEmpty2.default)(this.appliedFilters);
    }
  }, {
    key: "showInsuranceFilter",
    get: function get() {
      return (0, _itinerary.checkValidInsuranceDate)() && (0, _itinerary.checkInsuranceOnlyAvailable)(this.flightsFiltersParams);
    }
  }, {
    key: "extraBaggageSearch",
    get: function get() {
      return this.searchRoute;
    }
  }, {
    key: "isExtraBaggageEnabled",
    get: function get() {
      var isEconomy = _search.default.checkEconomyCabin(this.searchQuery);
      var isAlmosafer = this.$env.config.isAlmosafer;
      return isAlmosafer && isEconomy;
    }
  }, {
    key: "initializeAllFiltersState",
    value: function initializeAllFiltersState(initialFiltersQuery) {
      if (initialFiltersQuery === void 0) {
        initialFiltersQuery = '';
      }
      this.filtersState = _filter2.default.initializeAll(this.filtersData, this.filterKeys);
      if (initialFiltersQuery) {
        this.updateAllFiltersState(initialFiltersQuery);
      }
    }
  }, {
    key: "initializeFilterState",
    value: function initializeFilterState(filterKey) {
      if ((0, _includes2.default)(this.filterKeys, filterKey)) {
        this.filtersState[filterKey] = _filter2.default.initialize(filterKey, this.filtersData[filterKey]);
      }
    }
  }, {
    key: "resetAllFiltersState",
    value: function resetAllFiltersState() {
      this.initializeAllFiltersState();
    }
  }, {
    key: "resetSubFilterState",
    value: function resetSubFilterState(filterKey, filterPayload) {
      if ((0, _includes2.default)(this.filterKeys, filterKey)) {
        this.filtersState[filterKey] = _filter2.default.initializeSub({
          filterKey: filterKey,
          filterData: this.filtersData[filterKey],
          filterState: this.filtersState[filterKey],
          filterPayload: filterPayload
        });
      }
    }
  }, {
    key: "resetFilterState",
    value: function resetFilterState(filterKey) {
      this.initializeFilterState(filterKey);
    }
  }, {
    key: "updateAllFiltersState",
    value: function updateAllFiltersState(filtersQuery) {
      this.filtersState = _filter2.default.updateAll(this.filtersState, filtersQuery);
    }
  }, {
    key: "updateFilterState",
    value: function updateFilterState(filterKey, filterQuery) {
      if ((0, _includes2.default)(this.filterKeys, filterKey)) {
        var filterState = this.filtersState[filterKey];
        this.filtersState[filterKey] = _filter2.default.update({
          filterKey: filterKey,
          filterState: filterState,
          filterQuery: filterQuery
        });
      }
    }
  }, {
    key: "toggleFilterItemState",
    value: function toggleFilterItemState(filterKey, filterPayload) {
      var filterState = this.filtersState[filterKey];
      this.filtersState[filterKey] = _filter2.default.toggle({
        filterKey: filterKey,
        filterState: filterState,
        filterPayload: filterPayload
      });
    }
  }, {
    key: "toggleAllFilterItemState",
    value: function toggleAllFilterItemState(filterKey, filterCode) {
      var filterState = this.filtersState[filterKey];
      this.filtersState[filterKey] = _filter2.default.toggleAll({
        filterKey: filterKey,
        filterState: filterState,
        filterCode: filterCode
      });
    }
  }, {
    key: "setFilterItemState",
    value: function setFilterItemState(filterKey, filterPayload) {
      var filterState = this.filtersState[filterKey];
      this.filtersState[filterKey] = _filter2.default.set({
        filterKey: filterKey,
        filterState: filterState,
        filterPayload: filterPayload
      });
    }
  }, {
    key: "setAllFilterItemState",
    value: function setAllFilterItemState(filterKey, filterPayload) {
      var filterState = this.filtersState[filterKey];
      this.filtersState[filterKey] = _filter2.default.setAll({
        filterKey: filterKey,
        filterState: filterState,
        filterPayload: filterPayload
      });
    }
  }, {
    key: "updateFilterStateRange",
    value: function updateFilterStateRange(filterKey, filterRange) {
      var filterState = this.filtersState[filterKey];
      this.filtersState[filterKey] = _filter2.default.updateRange(filterState, filterRange);
    }
  }, {
    key: "filterOutNearbyAirports",
    value: function filterOutNearbyAirports() {
      this.updateFilterState('airport', this.searchResults.searchRequest.requestAirportsFilterQuery);
    }
  }, {
    key: "updateAppliedFilters",
    value: function updateAppliedFilters() {
      this.appliedFilters = _filter2.default.getAppliedFilters(this.filtersState, this.appliedFilters);
    }
  }, {
    key: "removeAppliedFilter",
    value: function removeAppliedFilter(appliedFilter) {
      if (!(0, _isPlainObject2.default)(appliedFilter) && !(0, _isPlainObject2.default)(appliedFilter.info)) return;
      if (appliedFilter.removalMode === 'reset') {
        this.resetFilterState(appliedFilter.info.key);
      } else {
        this.toggleFilterItemState(appliedFilter.info.key, appliedFilter.info);
      }
    }
  }, {
    key: "initializeSortKey",
    value: function initializeSortKey() {
      this.sortKey = _constants.DEFAULT_SORT_KEY;
    }
  }, {
    key: "selectedFlight",
    get: function get() {
      var itinerary = this.searchResults.getItinerary(this.selectedFlightId);
      var option = this.selectedExtraBaggageOption;
      return (0, _itineraryWithBaggage.default)(itinerary, option);
    }
  }, {
    key: "setSelectedFlightId",
    value: function setSelectedFlightId(itineraryId) {
      this.selectedFlightId = itineraryId;
    }
  }, {
    key: "setSelectedExtraBaggageOption",
    value: function setSelectedExtraBaggageOption(option) {
      this.selectedExtraBaggageOption = option;
    }
  }, {
    key: "setSortKey",
    value: function setSortKey(sortKey) {
      if ((0, _sort2.isValidSortKey)(sortKey)) {
        this.sortKey = sortKey;
        this.isSorted = true;
      }
    }
  }, {
    key: "setFilterKeys",
    value: function setFilterKeys(filterKeys) {
      if ((0, _isArray2.default)(filterKeys)) {
        this.filterKeys = filterKeys;
      }
    }
  }, {
    key: "initializeGroupPaths",
    value: function initializeGroupPaths() {
      this.groupPaths = _constants.DEFAULT_GROUP_PATHS;
    }
  }, {
    key: "setGroupPaths",
    value: function setGroupPaths(groupPaths) {
      if ((0, _group.isValidGroupPaths)(groupPaths)) {
        this.groupPaths = groupPaths;
      }
    }
  }, {
    key: "setSearchQuery",
    value: function setSearchQuery(query) {
      this.searchQuery = query;
    }
  }, {
    key: "setDateRange",
    value: function setDateRange(range) {
      this.dateRange = range;
    }
  }, {
    key: "setMinGroupLength",
    value: function setMinGroupLength(min) {
      this.minGroupLength = min;
    }
  }, {
    key: "initializeGroupsState",
    value: function initializeGroupsState() {
      var _this2 = this;
      var cb = function cb(group) {
        return (0, _group.initializeGroupState)(group, _this2.searchResults.itineraryLegHashMap);
      };
      this.groupsState = (0, _map2.default)(this.groupedSearchResults, cb);
    }
  }, {
    key: "updateGroupsState",
    value: function updateGroupsState(payload) {
      if (!(0, _isPlainObject2.default)(payload)) {
        return;
      }
      var groupIndex = payload.index;
      var groupState = this.groupsState[groupIndex];
      if (groupState) {
        var groupIds = (0, _map2.default)(this.groupedSearchResults[groupIndex], 'id');
        this.groupsState[groupIndex] = (0, _group.updateGroupState)({
          groupState: groupState,
          itineraryLegHashMap: this.searchResults.itineraryLegHashMap,
          payload: payload,
          groupIds: groupIds
        });
      }
    }
  }]);
  return FlightsAsyncSearchPageStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filtersState", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filterKeys", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants.DEFAULT_FILTER_KEYS;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "appliedFilters", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sortKey", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants.DEFAULT_SORT_KEY;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchQuery", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "dateRange", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants.PRICING_DATE_RANGE;
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "groupPaths", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants.DEFAULT_GROUP_PATHS;
  }
}), _descriptor8 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "groupsState", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor9 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectedFlightId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectedExtraBaggageOption", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "minGroupLength", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants.MIN_GROUP_LENGTH;
  }
}), _descriptor12 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isSorted", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "allSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "flightsFiltersParams", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "flightsFiltersParams"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filtersData", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filtersData"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filtersParams", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filtersParams"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filtersQuery", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filtersQuery"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "appliedFiltersCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "appliedFiltersCount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filteredSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filteredSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sortedSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortedSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "groupedSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupedSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "groupedByLegSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupedByLegSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sortPriceHashMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortPriceHashMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sortPriceDurationHashMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortPriceDurationHashMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "flexibleFlightsAvailable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "flexibleFlightsAvailable"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sortItinerariesHashMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortItinerariesHashMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "topPicks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "topPicks"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "topPicksHashMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "topPicksHashMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resultsWithoutTopPicks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "resultsWithoutTopPicks"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isTopPicksReady", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTopPicksReady"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "$sort", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "$sort"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resultsCheapestPrice", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "resultsCheapestPrice"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "groupCheapestPriceByDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupCheapestPriceByDate"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFiltered", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFiltered"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "firstNearbyIndex", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstNearbyIndex"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasNoResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasNoResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "shouldResetFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldResetFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isMultiCity", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMultiCity"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isEconomy", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEconomy"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasAdultsOnly", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasAdultsOnly"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFareCalendarAvailable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFareCalendarAvailable"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "shouldComparePricing", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldComparePricing"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "pricingFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pricingFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchRoute", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchRoute"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayPriceFilterState", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayPriceFilterState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "mergedAirlineFilterState", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "mergedAirlineFilterState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "availableAirlines", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "availableAirlines"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "marketingCampaigns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "marketingCampaigns"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "marketingCampaignsMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "marketingCampaignsMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "topCampaign", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "topCampaign"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchTopAirlines", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchTopAirlines"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "baseDepartureDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "baseDepartureDate"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "baseReturnDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "baseReturnDate"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "basePricingKey", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "basePricingKey"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "departureDateRange", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "departureDateRange"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "returnDateRange", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "returnDateRange"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "$filter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "$filter"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasNearbyAirports", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasNearbyAirports"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "parseSearchQuery", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "parseSearchQuery"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "availableAppliedFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "availableAppliedFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "totalFlightsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalFlightsCount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filteredFlightsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filteredFlightsCount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasQuickFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasQuickFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasAppliedFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasAppliedFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "showInsuranceFilter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showInsuranceFilter"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "extraBaggageSearch", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "extraBaggageSearch"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isExtraBaggageEnabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isExtraBaggageEnabled"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initializeAllFiltersState", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "initializeAllFiltersState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initializeFilterState", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFilterState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetAllFiltersState", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "resetAllFiltersState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetSubFilterState", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "resetSubFilterState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetFilterState", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "resetFilterState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateAllFiltersState", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "updateAllFiltersState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateFilterState", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "updateFilterState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "toggleFilterItemState", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "toggleFilterItemState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "toggleAllFilterItemState", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAllFilterItemState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setFilterItemState", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "setFilterItemState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setAllFilterItemState", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "setAllFilterItemState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateFilterStateRange", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "updateFilterStateRange"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filterOutNearbyAirports", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "filterOutNearbyAirports"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateAppliedFilters", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "updateAppliedFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "removeAppliedFilter", [_dec15], Object.getOwnPropertyDescriptor(_class.prototype, "removeAppliedFilter"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initializeSortKey", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "initializeSortKey"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectedFlight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedFlight"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setSelectedFlightId", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedFlightId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setSelectedExtraBaggageOption", [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedExtraBaggageOption"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setSortKey", [_dec19], Object.getOwnPropertyDescriptor(_class.prototype, "setSortKey"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setFilterKeys", [_dec20], Object.getOwnPropertyDescriptor(_class.prototype, "setFilterKeys"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initializeGroupPaths", [_dec21], Object.getOwnPropertyDescriptor(_class.prototype, "initializeGroupPaths"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setGroupPaths", [_dec22], Object.getOwnPropertyDescriptor(_class.prototype, "setGroupPaths"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setSearchQuery", [_dec23], Object.getOwnPropertyDescriptor(_class.prototype, "setSearchQuery"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setDateRange", [_dec24], Object.getOwnPropertyDescriptor(_class.prototype, "setDateRange"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setMinGroupLength", [_dec25], Object.getOwnPropertyDescriptor(_class.prototype, "setMinGroupLength"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initializeGroupsState", [_dec26], Object.getOwnPropertyDescriptor(_class.prototype, "initializeGroupsState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateGroupsState", [_dec27], Object.getOwnPropertyDescriptor(_class.prototype, "updateGroupsState"), _class.prototype)), _class));